// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.portfolio-page {
  padding: 2rem;
  background: #f8fafc;
  min-height: calc(100vh - 70px);
  width: 100%;
  box-sizing: border-box;
}

.portfolio-header {
  margin-bottom: 2rem;
}

.portfolio-title {
  font-size: 2rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 0.5rem 0;
}

.portfolio-subtitle {
  color: #64748b;
  font-size: 1rem;
  margin: 0;
}

.portfolio-config-selector {
  margin-top: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.portfolio-config-selector label {
  font-weight: 600;
  color: #374151;
  font-size: 0.9rem;
}

.portfolio-config-selector select {
  padding: 8px 12px;
  font-size: 14px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  background: white;
  color: #1e293b;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;
  min-width: 200px;
}

.portfolio-config-selector select:hover {
  border-color: #667eea;
}

.portfolio-config-selector select:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.card {
  background: white;
  padding: 1.5rem;
  border-radius: 0.75rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s, box-shadow 0.2s;
}

.card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.section {
  background: white;
  border-radius: 0.75rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin-bottom: 2rem;
}

.section h2 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #e5e7eb;
}

.section-body {
  padding: 1rem 1.5rem 1.5rem 1.5rem;
}

.table-responsive {
  width: 100%;
  overflow-x: auto;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
}

.data-table th,
.data-table td {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #e5e7eb;
  text-align: left;
  white-space: nowrap;
}

.data-table thead th {
  background: #f9fafb;
  color: #374151;
  font-weight: 600;
}

.data-table tbody tr:hover {
  background: #f9fafb;
}

.error-text {
  color: #ef4444;
}

.action-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  font-size: 0.85rem;
  font-weight: 600;
}

.action-badge.buy {
  background: #e8f5e9;
  color: #2e7d32;
}

.action-badge.sell {
  background: #ffebee;
  color: #c62828;
}

.status-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  font-size: 0.85rem;
  font-weight: 600;
}

.status-badge.status-filled {
  background: #e8f5e9;
  color: #2e7d32;
}

.status-badge.status-pending,
.status-badge.status-new,
.status-badge.status-pending_new,
.status-badge.status-accepted,
.status-badge.status-pending_replace {
  background: #fff3e0;
  color: #e65100;
}

.status-badge.status-canceled,
.status-badge.status-expired,
.status-badge.status-rejected {
  background: #ffebee;
  color: #c62828;
}

/* Harmonisation avec Users pour erreurs/chargement */
.error-message {
  background: #fed7d7;
  border: 1px solid #feb2b2;
  color: #c53030;
  padding: 1rem;
  border-radius: 0.5rem;
  margin-bottom: 1.5rem;
  font-size: 0.875rem;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  gap: 1rem;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(102, 126, 234, 0.3);
  border-radius: 50%;
  border-top-color: #667eea;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

@media (max-width: 768px) {
  .portfolio-page {
    padding: 1rem;
  }
}


`, "",{"version":3,"sources":["webpack://./src/pages/AlpacaPortfolio.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,wCAAwC;EACxC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;EAKE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,qDAAqD;AACrD;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".portfolio-page {\n  padding: 2rem;\n  background: #f8fafc;\n  min-height: calc(100vh - 70px);\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.portfolio-header {\n  margin-bottom: 2rem;\n}\n\n.portfolio-title {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin: 0 0 0.5rem 0;\n}\n\n.portfolio-subtitle {\n  color: #64748b;\n  font-size: 1rem;\n  margin: 0;\n}\n\n.portfolio-config-selector {\n  margin-top: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.portfolio-config-selector label {\n  font-weight: 600;\n  color: #374151;\n  font-size: 0.9rem;\n}\n\n.portfolio-config-selector select {\n  padding: 8px 12px;\n  font-size: 14px;\n  border-radius: 6px;\n  border: 1px solid #d1d5db;\n  background: white;\n  color: #1e293b;\n  cursor: pointer;\n  transition: border-color 0.2s, box-shadow 0.2s;\n  min-width: 200px;\n}\n\n.portfolio-config-selector select:hover {\n  border-color: #667eea;\n}\n\n.portfolio-config-selector select:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.cards-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.card {\n  background: white;\n  padding: 1.5rem;\n  border-radius: 0.75rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.section {\n  background: white;\n  border-radius: 0.75rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  margin-bottom: 2rem;\n}\n\n.section h2 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #1e293b;\n  margin: 0;\n  padding: 1.25rem 1.5rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.section-body {\n  padding: 1rem 1.5rem 1.5rem 1.5rem;\n}\n\n.table-responsive {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.data-table th,\n.data-table td {\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid #e5e7eb;\n  text-align: left;\n  white-space: nowrap;\n}\n\n.data-table thead th {\n  background: #f9fafb;\n  color: #374151;\n  font-weight: 600;\n}\n\n.data-table tbody tr:hover {\n  background: #f9fafb;\n}\n\n.error-text {\n  color: #ef4444;\n}\n\n.action-badge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 4px;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.action-badge.buy {\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n.action-badge.sell {\n  background: #ffebee;\n  color: #c62828;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 4px;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.status-badge.status-filled {\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n.status-badge.status-pending,\n.status-badge.status-new,\n.status-badge.status-pending_new,\n.status-badge.status-accepted,\n.status-badge.status-pending_replace {\n  background: #fff3e0;\n  color: #e65100;\n}\n\n.status-badge.status-canceled,\n.status-badge.status-expired,\n.status-badge.status-rejected {\n  background: #ffebee;\n  color: #c62828;\n}\n\n/* Harmonisation avec Users pour erreurs/chargement */\n.error-message {\n  background: #fed7d7;\n  border: 1px solid #feb2b2;\n  color: #c53030;\n  padding: 1rem;\n  border-radius: 0.5rem;\n  margin-bottom: 1.5rem;\n  font-size: 0.875rem;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem;\n  gap: 1rem;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid rgba(102, 126, 234, 0.3);\n  border-radius: 50%;\n  border-top-color: #667eea;\n  animation: spin 1s ease-in-out infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n@media (max-width: 768px) {\n  .portfolio-page {\n    padding: 1rem;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
